<template>
  <div class="ownership-main">
    <Menus :menu="menus" @menuClicked="menuClicked" />
    <div class="right-container">
      <TableBox title="Vehicle Ownership" :tableData="vehicleOwnershipList" :selectedRow.sync="selectedOwnership" :loading="vehicleOwnershipLoading"/>
    </div>

    <PopupEntry v-if="popupEntryShow" :show.sync="popupEntryShow" :title="popupEntryTitle" :createdBy="createdBy"
      :disabledSave="popupEntryDisabledSave" :updatedBy="updatedBy" :viewMode="viewMode"
      :requiredError="requiredError" :errorMessages="errorMessage" :successMessages="successMessage" 
      @save="saveVehicleOwnership" @requiredClicked="requiredClicked" :cancelButton="viewMode ? 'Close' : 'Cancel'">
      <div class="ownerhip-code">
        <Input placeholder="Ownership (max. 30 characters)" :inputValue.sync="ownership" :isRequired="true" ref="ownershipField"
          :isDisabled="viewMode || popupEntryTitle == 'Edit Vehicle Ownership'" validator="text,30,,alphanumeric,spacedash" :errorMessage.sync="ownershipError"/>
      </div>
      <div class="details">
        <RemarksBox title="Description" maxLength="100" ref="descBox" :isDisabled="viewMode" :text.sync="description"/>
        <div class="additional-details">
          <Dropdown placeholder="Issue Petrol Chit" :isDisabled="viewMode" :items="optionsForDropdown" itemKey="label"
            :selectedObject.sync="issuePetrolChit" />
          <InputQuery placeholder="Creditor" :isDisabled="viewMode" :items="creditorCodeData" itemKey="Creditor Code"
            descKey="Creditor Name" :selectedObject.sync="creditorCode" />
        </div>
      </div>
      <div>

      </div>

    </PopupEntry>

  </div>
</template>

<script>

export default {
  data: function () {
    return {
      //side menu list
      menus: [
        { title: 'New Ownership', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', key: 'MnuNew', visible: true, enabled: true },
        { title: 'Edit Ownership', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', key: 'MnuEdit', visible: true, enabled: true },
        { title: 'Delete Ownership', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png', key: 'MnuDelete', visible: true, enabled: true },
        { title: 'View Ownership', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png', key: 'MnuQuery', visible: true, enabled: true }
      ],

      //table
      vehicleOwnershipLoading: false,
      vehicleOwnershipList: [],
      selectedOwnership: [],

      //popup entry
      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      errorMessage: [],
      requiredError: [],
      successMessage: [],
      optionsForDropdown: [
        { "label": "Yes", "API_Value": "YES", "Value": 1 },
        { "label": "No", "API_Value": "NO", "Value": 0 },
      ],

      //fields
      ownership: '', ownershipError: '',
      description: '', descriptionError: '',
      issuePetrolChit: null,
      creditorCode: null,
      saveAction: '',
      creditorCodeData: [],
      popupEntryDisabledSave: false,
    }
  },
  methods: {

    getVehicleOwnership: async function () {
      this.vehicleOwnershipLoading = true;
      this.vehicleOwnershipList = [];
      this.vehicleOwnershipList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLEOWNERSHIP', jobtype: 'A' });
      this.vehicleOwnershipLoading = false;
    },
    getCreditorInfo: async function () {
      this.$fullscreenLoading('Getting Creditor Codes');
      this.creditorCodeData = [];
      this.creditorCodeData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'creditor' });
      this.$fullscreenLoading();
    },
    saveVehicleOwnership: async function () {
      this.requiredError = [];
      this.errorMessage = [];
      this.successMessage = [];

      if (this.ownership.trim().length <= 0){
        this.ownershipError = 'Ownership is Required!';
        this.requiredError.push({key: 'ownershipField', value: this.ownershipError});
        return;
      } 
      
      if (this.ownership.trim().length > 30){
        this.ownershipError = 'Error! Ownership cannot be more than 30 characters';
        this.requiredError.push({key: 'ownershipField', value: this.ownershipError});
        return;
      }

      if (this.description.length > 100) {
        this.descriptionError = 'Error! Description cannot be more than 100 characters'
        this.requiredError.push({key: 'descBox', value: this.descriptionError});
        return;
      }

      var dataToPost = {
        ownership: this.ownership.trim(),
        description: this.description,
        chitissuance: this.issuePetrolChit ? this.issuePetrolChit.Value : '',
        payeecode: this.creditorCode ? this.creditorCode['Creditor Code'] : '',
        action: this.saveAction
      }

      this.$fullscreenLoading('Saving Vehicle Ownership');
      var postUpdate = await this.$apiCallV2('/VehicleOwnership/SaveVehicleOwnership', dataToPost);
      this.$fullscreenLoading();

      if (postUpdate[0].Results >= 1) {
        this.errorMessage.push('There was an error creating Vehicle Ownership' + postUpdate[0].ErrMsg);
      } else {
        this.viewMode = true;
        this.successMessage.push(postUpdate[0].ErrMsg);
        this.popupEntryTitle = 'View Ownership'
        this.popupEntryDisabledSave = true;

        this.getVehicleOwnership();
        if (this.saveAction == "D") {
          this.$showAlert('success', 'Vehicle Ownership Deleted', postUpdate[0].ErrMsg);
        }
      }
    },
    menuClicked: async function (e) {
      this.popupEntryDisabledSave = false;
      switch (e['title']) {
        case 'New Ownership':
          this.clearOwnershipDetails();
          this.popupEntryShow = true;
          this.popupEntryTitle = 'New Vehicle Ownership';
          this.saveAction = 'N'
          this.issuePetrolChit = this.optionsForDropdown[0];
          break;
        case 'Edit Ownership':
          if (this.selectedOwnership.length == 0) {
            this.$showAlert('error', 'No vehicle ownership selected', 'Please select a vehicle ownership to edit');
          }
          else {
            this.popupEntryShow = true;
            this.popupEntryTitle = "Edit Vehicle Ownership";
            this.populateOwnershipDetails();
            this.saveAction = 'E'
          }
          break;
        case 'View Ownership':
          if (this.selectedOwnership.length == 0) {
            this.$showAlert('error', 'No vehicle ownership selected', 'Please select a vehicle ownership to view');
          }
          else {
            this.popupEntryShow = true;
            this.popupEntryTitle = "View Vehicle Ownership";
            this.populateOwnershipDetails();
            this.viewMode = true;
          }
          break;
        case 'Delete Ownership':
          if (this.selectedOwnership.length == 0) {
            this.$showAlert('error', 'No vehicle ownership selected', 'Please select a vehicle ownership to delete');
          }
          else {
            let deleting = await this.$showAlert('warning', 'Delete Vehicle Ownership', `Are you sure you want to delete vehicle ownership ${this.selectedOwnership[0]['Ownership']}? `,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ]);

            if (deleting == 'Delete') {
              this.saveAction = 'D'
              this.ownership = this.selectedOwnership[0]['Ownership'];
              this.saveVehicleOwnership();
            }
          }
          break;
      }
    },
    requiredClicked: function(e) {
      this.$refs[e].setFocus();
    },
    populateOwnershipDetails: function () {
      this.clearOwnershipDetails();
      this.ownership = this.selectedOwnership[0]['Ownership'],
        this.description = this.selectedOwnership[0]['Description'],
        this.issuePetrolChit = this.populateObject(this.optionsForDropdown, 'API_Value', this.selectedOwnership[0]['Chit Issuance']);
      if (this.selectedOwnership[0]['Creditor']) {
        let code = this.selectedOwnership[0]['Creditor'].match(/\[(.*?)\]/g);
        if (code) {
          code = code[0].substring(1, code[0].length - 1);
          this.creditorCode = this.creditorCodeData.getSelected(code, 'Creditor Code');
        }
      }
      this.updatedBy = `${this.selectedOwnership[0]['UserID']} ${this.selectedOwnership[0]['DateUpdated']}`;
    },
    populateObject: function (data, key, compare) { // To populate object into dropdown or input query
      try {
        return data.find(d => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },

    clearOwnershipDetails: function () {
      this.viewMode = false;
        this.ownership = '';
        this.ownershipError = '';
        this.description = '';
        this.issuePetrolChit = null;
        this.creditorCode = null;
        this.createdBy = '';
        this.updatedBy = '';
        this.saveAction = '';
        this.successMessage = [];
        this.errorMessage = [];
        this.requiredError = [];
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Vehicle Ownership') {
        x.data.forEach(k => {
          //key in menu same as control value from api
          let selectedMenu = this.menus.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        })
      }
    });

    await this.getVehicleOwnership();
    await this.getCreditorInfo();

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Ownership' });
    }
  },
  watch: {
    popupEntryShow: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) { // When the cancel is click but is not saved (for query new=1)
        let closeWindow = await this.$showAlert('warning', 'Cancelling Vehicle Ownership Creation', `You have not created an Vehicle Ownership profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`, [
          { "text": "Continue Creating" },
          { "text": "Cancel Creating", "color": "red", "textColor": "white" }
        ]);

        if (closeWindow == 'Cancel Creating') { // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.ownership-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  >.right-container {
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 5px;
    margin-left: 5px;
    border-radius: 5px;
  }

}

.additional-details {
  padding-top: 3px;
}
</style>